import withOptionSimpleSelect from "../hoc/withOptionsSimpleSelect";
import SimpleSelect from "../view/components/plugins/SimpleSelect";

export default withOptionSimpleSelect(SimpleSelect);